import { render, staticRenderFns } from "./uploadComics.vue?vue&type=template&id=372cb3e6&scoped=true&"
import script from "./uploadComics.vue?vue&type=script&lang=js&"
export * from "./uploadComics.vue?vue&type=script&lang=js&"
import style0 from "./uploadComics.vue?vue&type=style&index=0&id=372cb3e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372cb3e6",
  null
  
)

export default component.exports